import React, {useState} from 'react';

export const polyfillsInject = async () => {
    if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window)) {
        await import(
            /* webpackPreload: true */ /* webpackChunkName: "intersection-observer" */ 'intersection-observer'
        );
        if (!('MutationObserver' in window)) {
            // If the browser running the tests doesn't support MutationObserver,
            // fall back to polling.
            window.IntersectionObserver.prototype.POLL_INTERVAL =
                window.IntersectionObserver.prototype.THROTTLE_TIMEOUT || 100;
        }
    }

    // add useId for react 17, delete after going on react 18
    let counter = 1;
    React.useId = () => {
        const [id] = useState(() => `useId-${(counter += 1)}`);
        return id;
    };
};
